import { safeSetItem } from '@/components/shared/SafeSetItem';

export const fetchAndCacheWithoutPage = async <T>(
  apiCall: () => Promise<T>,
  apiUrl: string,
): Promise<T> => {
  const cachedData = localStorage.getItem(apiUrl);
  const expiryDays = process.env.NEXT_PUBLIC_CASH_STORAGE_EXPIRY || 3;

  if (cachedData) {
    try {
      const parsedData = JSON.parse(cachedData);
      const { timestamp, data } = parsedData;
      const now = new Date().getTime();

      if (now - timestamp < Number(expiryDays) * 60 * 60 * 1000) {
        return data;
      }
    } catch (err) {
      console.warn(`Error parsing cached data for key ${apiUrl}`, err);
    }
  }

  const response = await apiCall();
  const timestamp = new Date().getTime();

  safeSetItem(apiUrl, JSON.stringify({ timestamp, data: response }));

  return response;
};
